export default [
    {
        "id": 0,
        "nombre": "capital",
        "descripcion": "CENTRO JUDICIAL CAPITAL",
        "color": "#0073B9",
        "clase_centro": "center-blue",
        "clase_contenedor": "div-blue",
        "image": "/img/logo-oga.png",
        "shortname": "OGA CAPITAL",
    },
    {
        "id": 1,
        "nombre": "cjc",
        "descripcion": "CENTRO JUDICIAL CONCEPCIÓN",
        "color": "#6B962D",
        "clase_centro": "center-green",
        "clase_contenedor": "div-green",
        "image": "/img/logo-oga.png",
        "shortname": "OGA CJC",
    },
    {
        "id": 2,
        "nombre": "cjm",
        "descripcion": "CENTRO JUDICIAL MONTEROS",
        "color": "#F3961D",
        "clase_centro": "center-orange",
        "clase_contenedor": "div-orange",
        "image": "/img/logo-oga.png",
        "shortname": "OGA CJM",
    },
    {
        "id": 3,
        "nombre": "demo",
        "descripcion": "DEMO",
        "color": "#B71375",
        "clase_centro": "center-pink",
        "clase_contenedor": "div-pink",
        "image": "/img/logo-oga.png",
        "shortname": "OGA DEMO",
    },
    {
        "id": 4,
        "nombre": "santafe",
        "descripcion": "OGA SANTA FE",
        "color": "#6B962D",
        "clase_centro": "center-green",
        "clase_contenedor": "div-green",
        "image": "/img/logo-oga-santafe.png",
        "shortname": "OGJ SANTA FE",
    },

]